export default __webpack_public_path__ + "static/media/goshen82.de951244.jpg";